import { PLAYER_API_URL } from 'utils/urls';

export async function getLobby(signal?: AbortSignal): Promise<any> {
  for (let attempt = 0; attempt < 3; attempt += 1) {
    if (attempt > 0 && !signal?.aborted) {
      // A 409 means the snapshot changed mid-page-walk. Under a herd (many
      // clients restarting at once against the same stale snapshot) retrying
      // immediately just collides again — back off with jitter so restarts
      // spread out instead of re-syncing in lockstep.
      await new Promise((resolve) => setTimeout(resolve, 150 * attempt + Math.random() * 150));
    }

    const snapshot = { texas: [] as any[], omaha: [] as any[] };
    let cursor: number | undefined;
    let snapshotId: string | undefined;
    let restart = false;

    do {
      const query =
        cursor === undefined
          ? ''
          : `?cursor=${cursor}&snapshotId=${encodeURIComponent(snapshotId || '')}`;
      const response = await fetch(`${PLAYER_API_URL}/lobby${query}`, {
        method: 'GET',
        headers: { Accept: 'application/json' },
        cache: 'no-store',
        signal
      });
      if (response.status === 409) {
        restart = true;
        break;
      }
      if (!response.ok) throw new Error(`Lobby request failed (${response.status})`);
      const page = await response.json();
      snapshot.texas.push(...(page.texas || []));
      snapshot.omaha.push(...(page.omaha || []));
      cursor = Number.isSafeInteger(page.nextCursor) ? page.nextCursor : undefined;
      snapshotId = typeof page.snapshotId === 'string' ? page.snapshotId : snapshotId;
    } while (cursor !== undefined);

    if (!restart) return snapshot;
  }

  throw new Error('Lobby changed repeatedly while loading');
}
